"use client";
import { useRef } from "react";

const Input = ({
  placeholder,
  type,
  width,
  mdwidth,
  label,
  state,
  setState,
  height,
  myLabel,
}) => {
  const reference = useRef();
  return (
    <>
      {label ? (
        <div className="flex flex-row md:flex-row gap-x-4">
          <label>{label}</label>
          <input type="checkbox" className="min-w-6 min-h-6" required />
        </div>
      ) : (
        <div
          className={`relative ${height} ${width} ${mdwidth} h-[28px] 2xl:h-[34px] drop-shadow-2xl  rounded-[100px] border-[#FFFFFF] border-[2px]`}
        >
          <div
            className={`w-full md:w-[100%]  pointer-events-none absolute top-0 left-0 right-0 h-4 2xl:h-4 rounded-t-[100px] bg-gradient-to-b from-gray-400 to-transparent`}
          ></div>
          <input
            type={type}
            placeholder={placeholder}
            className={`${height} w-full md:w-[100%] h-[28px] 2xl:h-[35px] rounded-2xl placeholder:text-start placeholder:text-[#4A4A4A] placeholder:text-[13px] md:placeholder:text-[15px] px-12`}
            value={state}
            ref={reference}
            onChange={() => setState(reference.current.value)}
          />
        </div>
      )}
    </>
  );
};

export default Input;
